"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.summarizeCoreApplicationObjects = exports.summarizeList = exports.mungeObjectOrArr = exports.reKeyItem = exports.getHydratedDatastoreKey = exports.getAcceptableDynamoDBKey = exports.getV5Hash = exports.getObjectHash = void 0;
const tslib_1 = require("tslib");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
Object.defineProperty(exports, "getObjectHash", { enumerable: true, get: function () { return iotv_v3_types_1.getObjectHash; } });
const uuid_1 = require("uuid");
const getV5Hash = (preHash) => (0, uuid_1.v5)(preHash, config_1.default.app.namespace_uuid);
exports.getV5Hash = getV5Hash;
const utfColon = '0x3A';
const utfUnderscore = '0x5F';
const utfHyphen = '0x2D';
const getAcceptableDynamoDBKey = (str) => str.replace(/:/g, utfColon).replace(/-/g, utfHyphen);
exports.getAcceptableDynamoDBKey = getAcceptableDynamoDBKey;
const getHydratedDatastoreKey = (dynamodbKey) => dynamodbKey.replace(new RegExp(utfColon, 'g'), ':').replace(new RegExp(utfHyphen, 'g'), '-');
exports.getHydratedDatastoreKey = getHydratedDatastoreKey;
/**
 * Function changes id, sk, pk and optionally type leaving pk unchanged if and edge - returns new item not mutates
 * @param item
 * @param newId
 * @param newTypeId
 * @returns
 */
const reKeyItem = (item, newId, newTypeId) => {
    let newKey = item.sk.replace(item.id, newId);
    if (newTypeId)
        newKey = newKey.replace(/^\S+:/, `${newTypeId}:`);
    if (item.sk === item.pk) {
        return { ...item, sk: newKey, pk: newKey, id: newId, type: newTypeId ?? item.type }; //
    }
    else {
        return { ...item, sk: newKey, id: newId, type: newTypeId ?? item.type };
    }
};
exports.reKeyItem = reKeyItem;
//WIP
const mungeObjectOrArr = (mungeFn, ob) => {
    if (ob) {
        if (typeof ob === 'object' && !(ob instanceof Date) && !(ob instanceof Array)) {
            Object.keys(ob).reduce((acc, k) => {
                return mungeFn(ob[k], acc);
            }, undefined);
        }
        else if (ob instanceof Date) {
        }
        else if (ob instanceof Array) {
            Object.values(ob).reduce((acc, v) => {
                return mungeFn(v, acc);
            }, undefined);
        }
    }
};
exports.mungeObjectOrArr = mungeObjectOrArr;
const summarizeList = (list, maxNames = 5) => {
    let summary = `${list.length.toString()}`;
    if (list.length < maxNames && list.every((item) => !!item.name)) {
        summary = list.map((item) => item.name).join(', ');
    }
    return summary;
};
exports.summarizeList = summarizeList;
const summarizeCoreApplicationObjects = (list) => {
    const typeList = {};
    list.reduce((a, c) => {
        const { type } = c;
        if (!typeList[type])
            typeList[type] = 0;
        typeList[type]++;
        return a;
    }, typeList);
    return typeList;
};
exports.summarizeCoreApplicationObjects = summarizeCoreApplicationObjects;
